import { render, staticRenderFns } from "./couponCheckRecord.vue?vue&type=template&id=277e6675&scoped=true"
import script from "./couponCheckRecord.vue?vue&type=script&lang=js"
export * from "./couponCheckRecord.vue?vue&type=script&lang=js"
import style0 from "./couponCheckRecord.vue?vue&type=style&index=0&id=277e6675&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277e6675",
  null
  
)

export default component.exports